import { promptVars } from '../variables';
import { structureBasePrompt } from './structureBasePrompt';
export const structureFixPrompt = structureBasePrompt
    .temp(0.5)
    .human('Give me a structure of the application')
    .ai(promptVars.structureStmts)
    .human(`
# There are some issues with the structure. Please fix them.
${promptVars.errors}
`);
//# sourceMappingURL=structureFixPrompt.js.map